import Caminho from "../Components/SobreNos/Caminho/Caminho";
import Historia from "../Components/SobreNos/Historia/Historia";
import Eventos from "../Components/SobreNos/Eventos/Eventos";
import Curiosidade from "../Components/SobreNos/Curiosidade/Curiosidade";
import Qualidade from "../Components/SobreNos/Qualidade/Qualidade";

export default function SobreNos() {
  return (
    <div>
      <Historia />
      <Caminho />
      <Qualidade />
      <Curiosidade />
      <Eventos />
    </div>
  );
}
